export enum TABS {
  GENERAL = 'general',
  HOME = 'home',
  INSIGHTS = 'insights',
  WORKERS = 'workers',
  WORKER_PROFILE = 'worker-profile',
  JOB_APPLICATIONS = 'job-applications',
  SUPPLIERS = 'supplier-hub',
  ENGAGEMENT_HUB = 'engagement-hub'
}
